import $ from "jquery"
import "jquery-blockui"


$(document).ready( function(){
    
    $(document).on("submit", "#subscribe-form", function(event){
        event.preventDefault();
        //Reference the container, and block it
        var $container = $(this).parents(".content")
        $container.block({
            css: {
                backgroundColor: "transparent",
                border: "none"
            },
            message: `
            <div class="d-flex justify-content-center">
                <div class="spinner-border" style="width: 3rem; height: 3rem;"></div>
            </div>
            `,
            baseZ: 1500,
            overlayCSS: {
                backgroundColor: "#26292D",
                opacity: .7,
                cursor: "wait"
            }            
        });
        
        //I would use fetch here, but as we're already importing JQuery, lets use that
        //Send request to signup for mailing list
        $.post( "/subscribe", $(this).serialize(), function( data ) {
            //Update the page with information
            $($container).html( data );
        });
        
    })
    
})